import { useMemo } from "react";
import BigNumber from "bignumber.js";
import { PropsWithClassName, cn, fAmount } from "kz-ui-sdk";
import styles from "./PrizeAmount.module.css";

interface PrizeAmountProps extends PropsWithClassName {
  amount: number | BigNumber | undefined;
  shiny?: boolean;
  fontSize?: string | number;
}

const PrizeAmount = ({ className, amount, shiny = true, fontSize }: PrizeAmountProps) => {
  const amountText = useMemo(() => fAmount(amount, {
    abbreviate: true,
  }), [amount]);

  return (
    <span
      className={cn(styles.prizeAmount, [shiny && styles.prizeAmountAnimated], "inline-block", className)}
      style={{ fontSize }}
      data-text={amountText}
    >
      {amountText}
    </span>
  );
};

export default PrizeAmount;
